import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { format } from '@shared/utilities/formatEmail';
import { environment } from '@env/environment';

const baseUrl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  constructor(private _http: HttpClient) {}

  checkEmail(username, data): Observable<any> {
    return this._http.post(
      `${baseUrl}/users/${format(username)}/check-email-profile`,
      data
    );
  }

  checkPassword(username, data): Observable<any> {
    return this._http.post(
      `${baseUrl}/users/${format(username)}/check-password`,
      data
    );
  }

  changePassword(username, data): Observable<any> {
    return this._http.post(
      `${baseUrl}/users/${format(username)}/change-password`,
      data
    );
  }

  changeEmail(username, data): Observable<any> {
    return this._http.post(
      `${baseUrl}/users/${format(username)}/change-email`,
      data
    );
  }
}
